<template>
  <div id="three-container" class="holographic-wrapper"></div>
</template>

<script>
import * as THREE from "three";
import ViewPort from "../../standerMaterialView1/src/viewPort";
// import * as dat from "dat.gui";

export default {
  mounted() {
    console.log("holographic page created.");
    console.log(window.ensureSharedWorkerPortStart)

    const worker = window.ensureSharedWorkerPortStart("holographic");
    console.log(worker)
    worker.port.onmessage = function (e) {
      console.log("onmessage:", e.data);
      if (e.data.source === "holographicController") {
        if (e.data.type === "videoParamsChange") {
          videoParams[e.data.key] = e.data.value;
        } else if (e.data.type === "model3dParamsChange") {
          model3dParams[e.data.key] = e.data.value;
        }
      } else if (e.data.source === "app") {
        if (e.data.type === "changeMode") {
          changeToMode(e.data.mode);
        } else if (e.data.type === "update") {
          switch (e.data.resType) {
            case 1://图片
              changeToMode(Modes.Image);
              updateHoloImage(e.data.url);
              break;
            case 2: //单个视频
              changeToMode(Modes.Video);
              updateHolo1Video(e.data.url);
              break;
            case 3: //270度视频
              changeToMode(Modes.Video);
              updateHolo3Video(
                e.data.front_url,
                e.data.left_url,
                e.data.right_url
              );
              break;
            case 4: //360度视频
              changeToMode(Modes.Video);
              updateHolo4Video(
                e.data.front_url,
                e.data.left_url,
                e.data.right_url,
                e.data.back_url
              );
              break;
            case 0x10: //3D模型
              changeToMode(Modes.Model3D);
              viewPort.updateScene(e.data.url);
              break;
          }
        } else if (e.data.type === "updateVideoTime") {
          updateVideoTime(e.data.time);
        } else if (e.data.type === "pauseVideo") {
          pauseVideo();
        } else if (e.data.type === "playVideo") {
          playVideo();
        } else if (e.data.type === "update3DCamera") {
          update3DCamera(e.data);
        }
      }
    };

    const videoParams = {
      frontX: 0,
      frontY: -0.5,
      frontRotation: 0,
      backX: 0,
      backY: 1,
      backRotation: 180,
      leftX: -1.2,
      leftY: 0.4,
      leftRotation: 90,
      rightX: 1.2,
      rightY: 0.4,
      rightRotation: -90,
      cameraFov: 50,
      cameraPos: 2.03,
      baseScale: 1,
    };

    const model3dParams = {
      frontX: 0.5,
      frontY: 0.25,
      frontRotation: 0,
      frontWidth: 0.85,
      frontHeight: 0.85,
      leftX: 0.18,
      leftY: 0.72,
      leftWidth: 0.85,
      leftHeight: 0.85,
      leftRotation: 0,
      rightX: 0.82,
      rightY: 0.72,
      rightWidth: 0.85,
      rightHeight: 0.85,
      rightRotation: 0,
      backX: 0.5,
      backY: 0.75,
      backWidth: 0.5,
      backHeight: 0.5,
      backRotation: 0,
    };

    worker.port.postMessage({
      source: "holographic",
      type: "start",
      params: {
        video: videoParams,
        model3d: model3dParams,
      },
    });

    const Modes = Object.freeze({
      Image: "image",
      Video: "video",
      Model3D: "model3d",
    });

    const container = document.getElementById("three-container");

    let mode;

    const viewPort = new ViewPort(container, {
      isHolographic: true,
    });
    viewPort.controls.enabled = false;

    const renderer = viewPort.renderer;

    const camera = viewPort.camera;
    const scene = viewPort.scene;
    const background = new THREE.Color(0);

    const videoPlaneGroup = new THREE.Group();
    let frontPlane, backPlane, leftPlane, rightPlane;
    let frontVideo, backVideo, leftVideo, rightVideo;

    function initVideoPlanes() {
      const geometry = new THREE.PlaneGeometry();
      //front
      frontPlane = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({
          transparent: true,
          color: 0xffffff,
          side: THREE.DoubleSide,
        })
      );
      videoPlaneGroup.add(frontPlane);
      //back
      backPlane = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({
          transparent: true,
          color: 0xffffff,
          side: THREE.DoubleSide,
        })
      );
      videoPlaneGroup.add(backPlane);
      //left
      leftPlane = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({
          transparent: true,
          color: 0xffffff,
          side: THREE.DoubleSide,
        })
      );
      videoPlaneGroup.add(leftPlane);
      //right
      rightPlane = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({
          transparent: true,
          color: 0xffffff,
          side: THREE.DoubleSide,
        })
      );
      videoPlaneGroup.add(rightPlane);
    }

    initVideoPlanes();

    function updateVideoPlanesSize() {
      const baseScale = videoParams.baseScale;

      if (frontVideo) {
        const video = frontVideo.image;
        const width = video.videoWidth || video.width;
        const height = video.videoHeight || video.height;
        const aspect = (width / height) * baseScale;
        frontPlane.scale.set(aspect, baseScale, baseScale);
      }
      if (backVideo) {
        const video = backVideo.image;
        const width = video.videoWidth || video.width;
        const height = video.videoHeight || video.height;
        const aspect = (width / height) * baseScale;
        backPlane.scale.set(aspect, baseScale, baseScale);
      }
      if (leftVideo) {
        const video = leftVideo.image;
        const width = video.videoWidth || video.width;
        const height = video.videoHeight || video.height;
        const aspect = (width / height) * baseScale;
        leftPlane.scale.set(aspect, baseScale, baseScale);
      }
      if (rightVideo) {
        const video = rightVideo.image;
        const width = video.videoWidth || video.width;
        const height = video.videoHeight || video.height;
        const aspect = (width / height) * baseScale;
        rightPlane.scale.set(aspect, baseScale, baseScale);
      }
    }

    function createVideoElement(url, onLoad) {
      const videoElement = document.createElement("video");
      videoElement.crossOrigin = "*";
      videoElement.autoplay = true;
      videoElement.muted = true;
      videoElement.loop = true;
      videoElement.onerror = function (error) {
        console.error("error:", error);
      };
      videoElement.onloadedmetadata = function () {
        console.log("onloadedmetadata:", url);
        if (onLoad) callback(videoElement);
      };
      videoElement.onloadeddata = function () {
        console.log("onloadeddata:", url);
      };
      videoElement.src = url;

      videoElement.style.position = "absolute";
      videoElement.style.left = "0";
      videoElement.style.top = "0";
      videoElement.style.zIndex = "-9999";
      document.body.appendChild(videoElement);
      return videoElement;
    }

    function destroyVideoElement(videoElement) {
      if (typeof videoElement.pause === 'function')
        videoElement.pause();
      videoElement.loop = false;
      videoElement.removeAttribute("src");
      if (typeof videoElement.load === 'function')
        videoElement.load();
      if (videoElement.parentNode)
        videoElement.parentNode.removeChild(videoElement);
    }

    function destroyVideoTexture(videoTexture) {
      destroyVideoElement(videoTexture.image);
      videoTexture.dispose();
    }

    function updateVideoTime(time) {
      if (frontVideo) frontVideo.image.currentTime = time;
      if (leftVideo) leftVideo.image.currentTime = time;
      if (rightVideo) rightVideo.image.currentTime = time;
      if (backVideo) backVideo.image.currentTime = time;
    }

    function pauseVideo() {
      if (frontVideo) frontVideo.image.pause();
      if (leftVideo) leftVideo.image.pause();
      if (rightVideo) rightVideo.image.pause();
      if (backVideo) backVideo.image.pause();
    }

    function playVideo() {
      if (frontVideo) frontVideo.image.play();
      if (leftVideo) leftVideo.image.play();
      if (rightVideo) rightVideo.image.play();
      if (backVideo) backVideo.image.play();
    }

    function updateHolo4Video(frontPath, backPath, leftPath, rightPath) {
      if (frontPath) {
        if (frontVideo) {
          destroyVideoTexture(frontVideo);
          frontVideo = null;
        }
        const element = createVideoElement(frontPath);
        frontVideo = new THREE.VideoTexture(element);
        frontPlane.material.map = frontVideo;
        frontPlane.material.needsUpdate = true;
        frontPlane.visible = true;
      } else {
        frontPlane.visible = false;
      }

      if (backPath) {
        if (backVideo) {
          destroyVideoTexture(backVideo);
          backVideo = null;
        }
        const element = createVideoElement(backPath);
        backVideo = new THREE.VideoTexture(element);
        backPlane.material.map = backVideo;
        backPlane.material.needsUpdate = true;
        backPlane.visible = true;
      } else {
        backPlane.visible = false;
      }

      if (leftPath) {
        if (leftVideo) {
          destroyVideoTexture(leftVideo);
          leftVideo = null;
        }
        const element = createVideoElement(leftPath);
        leftVideo = new THREE.VideoTexture(element);
        leftPlane.material.map = leftVideo;
        leftPlane.material.needsUpdate = true;
        leftPlane.visible = true;
      } else {
        leftPlane.visible = false;
      }

      if (rightPath) {
        if (rightVideo) {
          destroyVideoTexture(rightVideo);
          rightVideo = null;
        }
        const element = createVideoElement(rightPath);
        rightVideo = new THREE.VideoTexture(element);
        rightPlane.material.map = rightVideo;
        rightPlane.material.needsUpdate = true;
        rightPlane.visible = true;
      } else {
        rightPlane.visible = false;
      }
    }

    function updateHolo3Video(frontPath, leftPath, rightPath) {
      if (frontPath) {
        if (frontVideo) {
          destroyVideoTexture(frontVideo);
          frontVideo = null;
        }
        const element = createVideoElement(frontPath);
        frontVideo = new THREE.VideoTexture(element);
        frontPlane.material.map = frontVideo;
        frontPlane.material.needsUpdate = true;
        frontPlane.visible = true;
      } else {
        frontPlane.visible = false;
      }

      if (leftPath) {
        if (leftVideo) {
          destroyVideoTexture(leftVideo);
          leftVideo = null;
        }
        const element = createVideoElement(leftPath);
        leftVideo = new THREE.VideoTexture(element);
        leftPlane.material.map = leftVideo;
        leftPlane.material.needsUpdate = true;
        leftPlane.visible = true;
      } else {
        leftPlane.visible = false;
      }

      if (rightPath) {
        if (rightVideo) {
          destroyVideoTexture(rightVideo);
          rightVideo = null;
        }
        const element = createVideoElement(rightPath);
        rightVideo = new THREE.VideoTexture(element);
        rightPlane.material.map = rightVideo;
        rightPlane.material.needsUpdate = true;
        rightPlane.visible = true;
      } else {
        rightPlane.visible = false;
      }

      if (backVideo) {
        destroyVideoTexture(backVideo);
        backVideo = null;
      }
      backPlane.visible = false;
    }

    function updateHoloImage(path) {
      if (frontVideo) {
        destroyVideoTexture(frontVideo);
        frontVideo = null;
      }
      if (leftVideo) {
        destroyVideoTexture(leftVideo);
        leftVideo = null;
      }
      if (rightVideo) {
        destroyVideoTexture(rightVideo);
        rightVideo = null;
      }

      if (backVideo) {
        destroyVideoTexture(backVideo);
        backVideo = null;
      }
      backPlane.visible = false;

      if (path) {
        new THREE.TextureLoader().load(path, function(texture) {
          frontVideo = leftVideo = rightVideo = texture;
          frontPlane.material.map = frontVideo;
          frontPlane.material.needsUpdate = true;
          frontPlane.visible = true;
          leftPlane.material.map = leftVideo;
          leftPlane.material.needsUpdate = true;
          leftPlane.visible = true;
          rightPlane.material.map = rightVideo;
          rightPlane.material.needsUpdate = true;
          rightPlane.visible = true;
        }, undefined, function(error) {
          console.error(error);
        });
      } else {
        frontPlane.visible = false;
        leftPlane.visible = false;
        rightPlane.visible = false;
      }
    }

    function updateHolo1Video(path) {
      if (path) {
        if (frontVideo) {
          destroyVideoTexture(frontVideo);
          frontVideo = null;
        }
        if (leftVideo) {
          destroyVideoTexture(leftVideo);
          leftVideo = null;
        }
        if (rightVideo) {
          destroyVideoTexture(rightVideo);
          rightVideo = null;
        }
        const element = createVideoElement(path);
        frontVideo = leftVideo = rightVideo = new THREE.VideoTexture(element);
        frontPlane.material.map = frontVideo;
        frontPlane.material.needsUpdate = true;
        frontPlane.visible = true;
        leftPlane.material.map = leftVideo;
        leftPlane.material.needsUpdate = true;
        leftPlane.visible = true;
        rightPlane.material.map = rightVideo;
        rightPlane.material.needsUpdate = true;
        rightPlane.visible = true;
      } else {
        frontPlane.visible = false;
        leftPlane.visible = false;
        rightPlane.visible = false;
      }

      if (backVideo) {
        destroyVideoTexture(backVideo);
        backVideo = null;
      }
      backPlane.visible = false;
    }

    const mirrorRotation = THREE.Math.degToRad(180);

    function updateVideoParams() {
      frontPlane.position.set(videoParams.frontX, videoParams.frontY, 0);
      frontPlane.rotation.set(
        0,
        mirrorRotation,
        THREE.Math.degToRad(videoParams.frontRotation)
      );
      backPlane.position.set(videoParams.backX, videoParams.backY, 0);
      backPlane.rotation.set(
        0,
        mirrorRotation,
        THREE.Math.degToRad(videoParams.backRotation)
      );
      leftPlane.position.set(videoParams.leftX, videoParams.leftY, 0);
      leftPlane.rotation.set(
        0,
        mirrorRotation,
        THREE.Math.degToRad(videoParams.leftRotation)
      );
      rightPlane.position.set(videoParams.rightX, videoParams.rightY, 0);
      rightPlane.rotation.set(
        0,
        mirrorRotation,
        THREE.Math.degToRad(videoParams.rightRotation)
      );

      camera.position.set(0, 0, videoParams.cameraPos);
      camera.rotation.set(0, 0, 0);
      // camera.updateMatrixWorld();
      camera.fov = videoParams.cameraFov;
      camera.updateProjectionMatrix();
    }

    let frontCamera, leftCamera, rightCamera, backCamera;
    let holographic3DCamera;

    function init3DCameras() {
      const cameras = [];
      //front
      frontCamera = new THREE.PerspectiveCamera(
        camera.fov,
        camera.aspect,
        camera.near,
        camera.far
      );
      frontCamera.name = "frontCamera";
      frontCamera.viewport = new THREE.Vector4(0, 0, 1, 1);
      // camera.add(frontCamera);
      cameras.push(frontCamera);

      //left
      leftCamera = new THREE.PerspectiveCamera(
        camera.fov,
        camera.aspect,
        camera.near,
        camera.far
      );
      leftCamera.name = "leftCamera";
      leftCamera.viewport = new THREE.Vector4(0, 0, 1, 1);
      // camera.add(leftCamera);
      cameras.push(leftCamera);

      //right
      rightCamera = new THREE.PerspectiveCamera(
        camera.fov,
        camera.aspect,
        camera.near,
        camera.far
      );
      rightCamera.name = "rightCamera";
      rightCamera.viewport = new THREE.Vector4(0, 0, 1, 1);
      // camera.add(rightCamera);
      cameras.push(rightCamera);

      //back
      backCamera = new THREE.PerspectiveCamera(
        camera.fov,
        camera.aspect,
        camera.near,
        camera.far
      );
      backCamera.name = "backCamera";
      backCamera.viewport = new THREE.Vector4(0, 0, 1, 1);
      // camera.add(backCamera);
      // cameras.push(backCamera);

      holographic3DCamera = new THREE.ArrayCamera(cameras);
      holographic3DCamera.name = "holographic3DCamera";
      holographic3DCamera.add(frontCamera);
      holographic3DCamera.add(leftCamera);
      holographic3DCamera.add(rightCamera);
      holographic3DCamera.add(backCamera);
    }

    init3DCameras();

    function update3DCamera(data) {
      camera.position.copy(data.position);
      camera.quaternion.copy(data.quaternion);
      if (camera.fov !== data.fov) {
        camera.fov = data.fov;
        camera.updateProjectionMatrix();

        frontCamera.fov = data.fov;
        frontCamera.updateProjectionMatrix();

        leftCamera.fov = data.fov;
        leftCamera.updateProjectionMatrix();

        rightCamera.fov = data.fov;
        rightCamera.updateProjectionMatrix();

        backCamera.fov = data.fov;
        backCamera.updateProjectionMatrix();
      }
    }

    function updateModel3DParams() {
      holographic3DCamera.position.copy(camera.position);
      holographic3DCamera.quaternion.copy(camera.quaternion);
      if (holographic3DCamera.fov !== camera.fov) {
        holographic3DCamera.fov = camera.fov;
        holographic3DCamera.updateProjectionMatrix();
      }

      const windowWidth = viewPort.width;
      const windowHeight = viewPort.height;

      let x, y, width, height;
      //front
      width = windowWidth * model3dParams.frontWidth;
      height = windowHeight * model3dParams.frontHeight;
      x = windowWidth * model3dParams.frontX - width / 2;
      y = windowHeight * model3dParams.frontY - height / 2;
      frontCamera.viewport.set(
        Math.floor(x),
        Math.floor(y),
        Math.ceil(width),
        Math.ceil(height)
      );

      //left
      width = windowWidth * model3dParams.leftWidth;
      height = windowHeight * model3dParams.leftHeight;
      x = windowWidth * model3dParams.leftX - width / 2;
      y = windowHeight * model3dParams.leftY - height / 2;
      leftCamera.viewport.set(
        Math.floor(x),
        Math.floor(y),
        Math.ceil(width),
        Math.ceil(height)
      );
      leftCamera.rotation.z = THREE.Math.degToRad(model3dParams.leftRotation);

      //right
      width = windowWidth * model3dParams.rightWidth;
      height = windowHeight * model3dParams.rightHeight;
      x = windowWidth * model3dParams.rightX - width / 2;
      y = windowHeight * model3dParams.rightY - height / 2;
      rightCamera.viewport.set(
        Math.floor(x),
        Math.floor(y),
        Math.ceil(width),
        Math.ceil(height)
      );
      rightCamera.rotation.z = THREE.Math.degToRad(model3dParams.rightRotation);

      //back
      width = windowWidth * model3dParams.backWidth;
      height = windowHeight * model3dParams.backHeight;
      x = windowWidth * model3dParams.backX - width / 2;
      y = windowHeight * model3dParams.backY - height / 2;
      backCamera.viewport.set(
        Math.floor(x),
        Math.floor(y),
        Math.ceil(width),
        Math.ceil(height)
      );
      backCamera.rotation.z = THREE.Math.degToRad(model3dParams.backRotation);
    }

    viewPort.onCameraFitToObject = function (center, cameraZ) {
      frontCamera.position.x = 0;
      frontCamera.position.y = 0;
      frontCamera.position.z = 0;
      frontCamera.rotation.x = 0;
      frontCamera.rotation.y = 0;
      frontCamera.rotation.z = 0;

      leftCamera.position.x = -cameraZ;
      leftCamera.position.y = 0;
      leftCamera.position.z = -cameraZ;
      leftCamera.rotation.x = 0;
      leftCamera.rotation.y = THREE.Math.degToRad(-90);
      leftCamera.rotation.z = 0;

      rightCamera.position.x = cameraZ;
      rightCamera.position.y = 0;
      rightCamera.position.z = -cameraZ;
      rightCamera.rotation.x = 0;
      rightCamera.rotation.y = THREE.Math.degToRad(90);
      rightCamera.rotation.z = 0;

      backCamera.position.x = 0;
      backCamera.position.y = 0;
      backCamera.position.z = -cameraZ * 2;
      backCamera.rotation.x = 0;
      backCamera.rotation.y = THREE.Math.degToRad(180);
      backCamera.rotation.z = 0;
    };

    viewPort.onResize = function () {
      holographic3DCamera.aspect = camera.aspect;
      holographic3DCamera.updateProjectionMatrix();

      frontCamera.aspect = camera.aspect;
      frontCamera.updateProjectionMatrix();

      leftCamera.aspect = camera.aspect;
      leftCamera.updateProjectionMatrix();

      rightCamera.aspect = camera.aspect;
      rightCamera.updateProjectionMatrix();

      backCamera.aspect = camera.aspect;
      backCamera.updateProjectionMatrix();
    };

    viewPort.onUpdate = function () {
      scene.background = background;

      if (mode === Modes.Image || mode === Modes.Video) {
        updateVideoPlanesSize();
        updateVideoParams();
      } else if (mode === Modes.Model3D) {
        updateModel3DParams();
      }
    };

    viewPort.render = function () {
      if (mode === Modes.Image || mode === Modes.Video) {
        renderer.render(scene, camera);
      } else if (mode === Modes.Model3D) {
        renderer.render(scene, holographic3DCamera);
      }
    };

    function changeToMode(value) {
      if (mode !== value) {
        switch (value) {
          case Modes.Image:
          case Modes.Video:
            viewPort.clearScene();
            if (videoPlaneGroup.parent !== scene) 
              scene.add(videoPlaneGroup);
            renderer.setSize(container.offsetWidth, container.offsetHeight);
            break;
          case Modes.Model3D:
            scene.remove(videoPlaneGroup);
            break;
        }
        mode = value;
      }
    }

    changeToMode(Modes.Video);
    updateHolo1Video("./test.mp4");
    // updateHolo1Video("./test.webm");
    // changeToMode(Modes.Model3D);
    // viewPort.updateScene(
    //   "https://img5.gemtec.ltd/editorTest_sceneGltf/11522335-6B24-4852-99F9-C7EA2E0BDE2F.glb"
    // );

    // function initGUI() {
    //   const gui = new dat.GUI();

    //   gui.add(model3dParams, "frontX", 0, 1, 0.01);
    //   gui.add(model3dParams, "frontY", 0, 1, 0.01);
    //   gui.add(model3dParams, "frontWidth", 0, 1, 0.01);
    //   gui.add(model3dParams, "frontHeight", 0, 1, 0.01);
    //   gui.add(model3dParams, "leftX", 0, 1, 0.01);
    //   gui.add(model3dParams, "leftY", 0, 1, 0.01);
    //   gui.add(model3dParams, "leftWidth", 0, 1, 0.01);
    //   gui.add(model3dParams, "leftHeight", 0, 1, 0.01);
    //   gui.add(model3dParams, "rightX", 0, 1, 0.01);
    //   gui.add(model3dParams, "rightY", 0, 1, 0.01);
    //   gui.add(model3dParams, "rightWidth", 0, 1, 0.01);
    //   gui.add(model3dParams, "rightHeight", 0, 1, 0.01);
    //   gui.add(model3dParams, "backX", 0, 1, 0.01);
    //   gui.add(model3dParams, "backY", 0, 1, 0.01);
    //   gui.add(model3dParams, "backWidth", 0, 1, 0.01);
    //   gui.add(model3dParams, "backHeight", 0, 1, 0.01);

    //   gui.open();
    // }

    // initGUI();
  },
};
</script>

<style lang="scss" scoped>
.holographic-wrapper {
  width: 100%;
  height: 100%;
  background: #000;
}
</style>